import { Service } from "../../types/service";
import { TooltipLink } from "../../components/TooltipLink/TooltipLink";
import { AnimatedNumber } from "../../components/cardItem/AnimatedNumber";
import {
  openAddModelData,
  openUpdateModelData,
  setNewPackageModelTrue,
} from "../../store/slices/modalSlice";
import { useDispatch } from "react-redux";
import { useCart } from "../../hooks/useCart";
import alternateImg from "../../assets/alternateImg.jpeg";

interface ServiceListProps {
  allServices: Service[];
  slug: string;
}

const ServiceList = ({ allServices = [], slug = "" }: ServiceListProps) => {
  const dispatch = useDispatch();
  const { updateCartQuantity, getPriceIdByServiceId, countByService } =
    useCart();
  const handleOpenAddModalOnly = (
    service: Service,
    numberOfOptions: number,
    name: string,
    isPackage: boolean,
    isModel: boolean
  ) => {
    if (
      slug === "immigration" ||
      slug === "emirates-id" ||
      slug === "tas-heel" ||
      slug === "taw-jeeh" ||
      slug === "dubai-health-authority" ||
      slug === "legal-translation" ||
      slug === "al-adheed"
    ) {
      if (service?.PackageId) {
        sessionStorage.setItem(
          "packageMainId",
          JSON.stringify(service?.PackageId)
        );
      }
      if (numberOfOptions === 1) {
        sessionStorage.setItem(
          "PriceRecordId",
          JSON.stringify(service.prices[0].PriceRecordId)
        );
      }

      sessionStorage.setItem(
        "serviceid",
        JSON.stringify(service?.Recordid ?? 0)
      );
      dispatch(setNewPackageModelTrue());
    } else {
      handleOpenAddModal(service, numberOfOptions, name, isPackage, isModel);
    }
  };

  const handleOpenAddModal = (
    service: Service,
    numberOfOptions: number,
    name: string,
    isPackage: boolean,
    isModel: boolean
  ) => {
    if (isPackage !== true) {
      if (isModel !== true) {
        if (name === "add") {
          if (numberOfOptions > 1) {
            sessionStorage.setItem(
              "serviceid",
              JSON.stringify(service?.Recordid ?? 0)
            );
            dispatch(openAddModelData());
          } else {
            updateCartQuantity(
              service.prices[0].PriceRecordId,
              service.Recordid ?? 0,
              "plus"
            );
          }
        } else {
          sessionStorage.setItem(
            "serviceid",
            JSON.stringify(service.Recordid ?? 0)
          );
          dispatch(openAddModelData());
        }
      } else {
        sessionStorage.setItem(
          "serviceid",
          JSON.stringify(service?.Recordid ?? 0)
        );
        dispatch(openUpdateModelData());
      }
    } else {
      sessionStorage.setItem(
        "serviceid",
        JSON.stringify(service.Recordid ?? 0)
      );
      dispatch(openUpdateModelData());
    }
  };

  return (
    allServices &&
    allServices.map((service) => (
      <div
        className="list-card-main d-flex align-items-start align-items-md-center justify-content-between px-md-0 m-b-32 p-b-32"
        key={`service-${service.Recordid}`}
      >
        <div className="col-8">
          <div id={`inside_${service.Recordid}`} />
          {service.component}
          {service.isPackage || service.cat_id == 13 ? (
            <>
              <div className=" font-12 ff-semibold text-white d-flex align-items-center gap-2 bg-primary w-fit px-3 py-1 rounded-pill mb-2">
                <div className="d-flex align-items-center ">
                  <img
                    src="https://goodhand.b-cdn.net/Assets/Upload/gift.svg"
                    alt=""
                    style={{
                      height: "14px",
                      width: "auto",
                      objectFit: "contain",
                    }}
                  />
                </div>
                {/* <div>{mainCatName}</div> */}
                <div>Package</div>
              </div>
              <div className="sub-hd1" id={service.Recordid.toString()}>
                <p className="mb-0">{service.serviceName}</p>
              </div>
              {/* <span className="cart-cat-badge font-13 ff-semibold text-primary d-block">
                {mainCatName}
              </span> */}
            </>
          ) : (
            <div className="sub-hd1" id={service.Recordid.toString()}>
              <p className="mb-2 text-black font-16 ff-bold">
                {service.serviceName}
              </p>
            </div>
          )}
          <div className="d-flex align-items-center gap-2">
            {service.noOfApplication && (
              <div className="d-flex">
                <div
                  style={{
                    width: "14px",
                    height: "14px",
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginRight: "5px",
                  }}
                >
                  <svg
                    width="14"
                    height="17"
                    viewBox="0 0 14 17"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8.5 1.5V4.61111C8.5 4.81739 8.58194 5.01522 8.72781 5.16108C8.87367 5.30694 9.0715 5.38889 9.27778 5.38889H12.3889"
                      stroke="#6E42E5"
                      strokeWidth="1.55556"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M10.8333 15.5H3.05556C2.643 15.5 2.24733 15.3361 1.95561 15.0444C1.66389 14.7527 1.5 14.357 1.5 13.9444V3.05556C1.5 2.643 1.66389 2.24733 1.95561 1.95561C2.24733 1.66389 2.643 1.5 3.05556 1.5H8.5L12.3889 5.38889V13.9444C12.3889 14.357 12.225 14.7527 11.9333 15.0444C11.6416 15.3361 11.2459 15.5 10.8333 15.5Z"
                      stroke="#6E42E5"
                      strokeWidth="1.55556"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M4.61133 10.8333L6.16688 12.3889L9.27799 9.27777"
                      stroke="#6E42E5"
                      strokeWidth="1.55556"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>

                <span className="font-12 ff-medium text-muted">
                  {service.noOfApplication}
                </span>
              </div>
            )}
            {service.tooltipData !== null && (
              <TooltipLink
                title={service.tooltipData}
                Id={service.Recordid.toString()}
                styleName="none"
              >
                <div className="d-flex align-items-center gap-1 bg-beige include-main cursor-pointer">
                  <div
                    style={{
                      borderRadius: "50%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      marginRight: "5px",
                    }}
                  >
                    <img
                      src="https://goodhand.b-cdn.net/Assets/IconsNewServiceDetail/includes.svg"
                      className="img-fluid"
                      alt=""
                      style={{
                        width: "14px",
                        height: "14px",
                      }}
                    />
                  </div>

                  <span className="font-12 ff-medium ">Includes</span>
                </div>
              </TooltipLink>
            )}
          </div>

          <div className="d-flex align-items-center gap-2 flex-wrap">
            {service.prices.length > 1 ? (
              <div className="d-flex align-items-center gap-1 mt-1">
                <p className="text-black ff-bold font-14 mb-0">
                  <span className="ff-medium">Start from &nbsp;</span>
                  <span className="ff-currency ff-medium font-16"></span>
                  {Math.min(
                    ...service.prices.map((price) => price.PriceAmount)
                  ).toLocaleString()}
                </p>
              </div>
            ) : (
              service.prices.map((price) => (
                <div
                  className="d-flex align-items-center gap-1"
                  key={`price-${service.Recordid}-${price.PriceType}`}
                >
                  <p className="in-badge font-14 ff-bold mb-0 px-0">
                    <span className="ff-normal ">
                      {" "}
                      {service.isPackage && <>Start from &nbsp; </>}
                    </span>
                    <span className="ff-currency ff-medium font-16"></span>
                    {price.PriceAmount === 0
                      ? `${price.PriceType}`
                      : `${price.PriceAmount.toLocaleString()}`}
                    &nbsp;
                    {price.OldPriceAmount > price.PriceAmount &&
                      price.OldPriceAmount > price.PriceAmount && (
                        <s className="text-secondary ff-medium pe-1">
                          {price.PriceAmount !== 0}
                          &nbsp;
                          {Math.min(
                            ...service.prices.map(
                              (price) => price.OldPriceAmount
                            )
                          ).toLocaleString()}
                        </s>
                      )}
                  </p>
                </div>
              ))
            )}
          </div>
          <div className="custom-line"></div>
          {service.maxSaving >= 1 && (
            <div className="up-to">
              <span>
                <svg
                  width="12"
                  height="12"
                  viewBox="0 0 16 16"
                  fill="#07794C"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M15 7.929L8.472 1.4a.997.997 0 00-.904-.274l-5.04 1.008a.5.5 0 00-.393.393l-1.008 5.04a.998.998 0 00.274.904L7.928 15a.999.999 0 001.414 0L15 9.343a.999.999 0 000-1.414zM5.25 6a.75.75 0 110-1.5.75.75 0 010 1.5z"
                    fill="#07794C"
                  ></path>
                </svg>
              </span>
              <span className="font-12 ff-medium">
                <span className="ms-1">
                  Up to <span className="ff-currency ff-medium font-16"></span>{" "}
                  {service.maxSaving}&nbsp;
                </span>
                Off
              </span>
            </div>
          )}
          <p className="mb-1"></p>
          {service?.outsideDescriptionArray && (
            <div>
              {service?.outsideDescriptionArray?.map((description, index) => (
                <div
                  className="section"
                  key={`description-${service.Recordid}-${index}`}
                >
                  <ul className="sub-text">
                    <li
                      dangerouslySetInnerHTML={{
                        __html: description ?? "",
                      }}
                    ></li>
                  </ul>
                </div>
              ))}
            </div>
          )}

          <a
            className="btn-link ff-semibold font-14"
            onClick={() =>
              handleOpenAddModal(
                service,
                service.numberOfOptions,
                "ViewDetail",
                service.isPackage,
                service.isModel
              )
            }
            style={{
              cursor: "pointer",
              textDecoration: "none",

              color: "rgb(110, 66, 229)",
            }}
            rel="nofollow"
          >
            View Detail
          </a>
        </div>
        <div>
          <div className="image-container">
            {service.isPackage ? (
              <div>
                <img
                  loading="lazy"
                  src="https://goodhand.b-cdn.net/Assets/placeholder.png"
                  alt={service.imgAlt ?? service.serviceName}
                  className="image-bg"
                />
                <div className="packge-count-main w-100">
                  <span className="count">
                    {service.totalServiceCount || 5}
                  </span>
                  <span className="label">Services </span>
                </div>
              </div>
            ) : (
              <img
                loading="lazy"
                src={service.imageSrc ?? alternateImg}
                alt={service.imgAlt ?? service.serviceName}
                className="img-fluid d-block mx-auto"
              />
            )}
            {/* {service?.ServiceId} */}
            {getPriceIdByServiceId(service?.ServiceId) ? (
              <div className="d-flex flex-column align-items-center justify-content-center">
                <div className="d-flex align-items-center btn-add position-absolute gap-1 gap-md-2">
                  <button
                    className="bt-mi p-0"
                    onClick={() =>
                      updateCartQuantity(
                        service?.ServiceId,
                        getPriceIdByServiceId(service?.ServiceId),
                        "minus",
                        1
                      )
                    }
                  >
                    -
                  </button>
                  <span className="counter-numbers">
                    {/* (service?.ServiceId === carsummery?.ServiceId) ?? cartsummery.carsummery */}

                    <AnimatedNumber
                      value={countByService(service.ServiceId) || 0}
                    />
                  </span>
                  <button className="bt-plu p-0">+</button>
                </div>
              </div>
            ) : (
              <>
                {service.isPackage ? (
                  <div
                    className="btn-add position-absolute"
                    onClick={() =>
                      handleOpenAddModal(
                        service,
                        service.numberOfOptions,
                        "ViewDetail",
                        service.isPackage,
                        service.isModel
                      )
                    }
                  >
                    Add
                  </div>
                ) : (
                  <div
                    className="btn-add position-absolute"
                    onClick={() =>
                      handleOpenAddModalOnly(
                        service,
                        service.numberOfOptions,
                        "add",
                        service.isPackage,
                        service.isModel
                      )
                    }
                  >
                    Add
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    ))
  );
};
export default ServiceList;
